module.exports = __webpack_public_path__ + "img/10.19988d79.jpg";